"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var menuTriggerIcon_svg_1 = __importDefault(require("./menuTriggerIcon.svg"));
var react_2 = require("@emotion/react");
var defaultProps = {
    open: false,
};
var getCSSRules = function (_a) {
    var colors = _a.colors, borderRadius = _a.borderRadius;
    return ({
        open: {},
        trigger: {
            borderRadius: borderRadius.sm,
            userSelect: 'none',
            background: 'none',
            border: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            width: 'inherit',
            height: 'inherit',
            '&:hover': {
                backgroundColor: colors.Grey[100],
            },
            '$open &': {
                extend: 'activeTrigger',
            },
        },
        active: {
            backgroundColor: colors.Hannibal[100],
        },
    });
};
var DropdownMenuTrigger = function (_a) {
    var component = _a.component, open = _a.open, onClick = _a.onClick;
    var theme = (0, react_2.useTheme)();
    var styles = getCSSRules(theme);
    var handleClick = function (e) {
        e.stopPropagation();
        e.preventDefault();
        onClick();
    };
    if (component && (0, react_1.isValidElement)(component)) {
        var customTrigger = (0, react_1.cloneElement)(component, {
            onClick: handleClick,
            open: open,
        });
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: customTrigger }, void 0);
    }
    return ((0, jsx_runtime_1.jsx)(react_2.ClassNames, { children: function (_a) {
            var _b;
            var cx = _a.cx, css = _a.css;
            return ((0, jsx_runtime_1.jsx)("button", __assign({ onClick: handleClick, "aria-label": "Toggle menu", className: cx(css(styles.trigger), (_b = {}, _b[css(styles.active)] = open, _b)) }, { children: (0, jsx_runtime_1.jsx)("img", { src: menuTriggerIcon_svg_1.default, alt: "Toggle menu" }, void 0) }), void 0));
        } }, void 0));
};
DropdownMenuTrigger.defaultProps = defaultProps;
exports.default = DropdownMenuTrigger;
//# sourceMappingURL=DropdownMenuTrigger.js.map